<script lang="ts">
    import type { Models } from '@smartlinkdev/types';
    import { fade } from 'svelte/transition';
    import {
      roveDefaultFloor,
      floors,
      mapInstance,
      roveActiveFloor,
    } from '$lib/stores';
    import { t } from '$lib/translations';

    let activeFloorId: number;

    roveActiveFloor.subscribe((newFloor) => {
        if (newFloor && newFloor.id) {
            activeFloorId = newFloor.id;
        }
    });

    function changeFloor(floor: Models.Floor): void {
        if (isActiveFloor(floor)) {
            return;
        }
        roveActiveFloor.set(floor);
        $mapInstance.changeFloor(floor);
    }

    function isActiveFloor(floor: Models.Floor): boolean {
        return floor.id === activeFloorId;
    }

    function reset(): void {
        changeFloor($roveDefaultFloor);
        $mapInstance.reset();
    }
</script>

{#if $floors.length > 0}
  <div transition:fade={{ delay: 150, duration: 250 }} class="floor-changer">
    {#each $floors as floor}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
          class="floor-changer-floor"
          class:active={floor.id === activeFloorId}
          on:click={() => changeFloor(floor)}
      >
        {floor.name}
      </div>
    {/each}
    <button
      type="button"
      class="reset-btn"
      on:click={() => reset()}
    >
      { $t('content.reset') }
    </button>
  </div>
{/if}

<style lang="postcss">
    .floor-changer {
        @apply fixed bottom-1 left-1 bg-white w-32 text-center py-2 px-4 grid grid-cols-1 divide-y;
    }

    .floor-changer-floor {
        text-wrap: nowrap;
        @apply py-2;
    }

    .active {
        @apply font-bold;
    }

    .reset-btn {
        @apply mt-1 px-2 py-1 text-xs font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300;
    }
</style>
